import React from 'react';

const sizes = {
  default: `py-3 px-8`,
  lg: `py-4 px-12`,
  xl: `py-5 px-16 text-lg`
};

const Button = ({ children, className = '', size, border }) => {
  return (
    <button
      type="button"
      className={`
        ${sizes[size] || sizes.default}
        ${className}
        ${border ? 'text-primary border-2 border-primary hover:border-primary-darker' : 'bg-primary hover:bg-primary-darker text-white'}
    `}
    >
      {children}
    </button>
  );
};

export default Button;
